module.exports = __webpack_public_path__ + "static/Health-Intelligence-Analytics-c1e3ee52627fb3e5ffe2e374b0a3c33d.jpg";